import moment from 'moment';
import 'moment-duration-format';

export interface Date {
	source: moment.Moment | null;
	local: string;
	formatted: string;
	isNull: boolean;
}

export const createDate = (source: string | moment.Moment | null | undefined): Date => {
	if (source === null || source === undefined) {
		return {
			source: null,
			local: '',
			formatted: 'No Date',
			isNull: true
		};
	}
	const date = moment.utc(source);
	return {
		source: date,
		local: date.local().format('M/D/YYYY h:mm a'),
		formatted: date.format('M/D/YYYY'),
		isNull: false
	};
};
